import { render, staticRenderFns } from "./AppImportContactTable.vue?vue&type=template&id=8a80d4ea"
import script from "./AppImportContactTable.vue?vue&type=script&lang=js"
export * from "./AppImportContactTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports